"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyApiClient = void 0;
const axios = __importStar(require("axios"));
const ClientConfig_1 = __importDefault(require("./ClientConfig"));
const AUTH_TOKEN = "auth_token";
const REDIRECT_URL = "journey_redirect_url";
class ApiServiceImpl {
    constructor() {
        /**
         * @see https://axios-http.com/docs/handling_errors
         */
        this.errorFormatter = (error) => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(error.response);
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                return Promise.reject({
                    errorCode: error.response.status,
                    ...error.response.data
                });
            }
            else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                // console.log('Error', error.request);
                return Promise.reject({
                    errorCode: 500,
                    error: 'Internal Server Error',
                    message: 'Internal Server Error'
                });
            }
            else {
                // Something happened in setting up the request that triggered an Error
                // console.log('Error', error.message);
                return Promise.reject({
                    errorCode: 500,
                    error: error.message || 'Internal Application Error.',
                    message: error.message || 'Internal Application Error.'
                });
            }
        };
        this.axios = axios.default.create();
        this.apiRoot = ClientConfig_1.default.apiRoot;
        this.axios.interceptors.response.use((response) => response, (error) => this.errorFormatter(error));
    }
    setLanguage(languageId) {
        if (!languageId) {
            delete this.axios.defaults.headers.common['x-language'];
        }
        else {
            this.axios.defaults.headers.common['x-language'] = languageId;
        }
    }
    registerUser(userData) {
        return this.axios.post(`${this.apiRoot}/users`, userData)
            .then(response => response.data);
    }
    getCompany(companyCode) {
        return this.axios.get(`${this.apiRoot}/companies/${companyCode}`)
            .then(response => response.data);
    }
    saveMonthlyCheckinAnswers(data) {
        return this.axios.post(`${this.apiRoot}/checkin/monthly`, data, this.getHttpConfig())
            .then(response => response.data);
    }
    saveDailyCheckinAnswers(data) {
        return this.axios.post(`${this.apiRoot}/checkin/daily`, data, this.getHttpConfig())
            .then(response => response.data);
    }
    saveOnBoardingAnswers(data) {
        return this.axios.post(`${this.apiRoot}/checkin/onboarding`, data, this.getHttpConfig())
            .then(response => response.data);
    }
    getCurrentAssessment() {
        return this.axios.get(`${this.apiRoot}/checkin/current`, this.getHttpConfig())
            .then(response => response.data.code);
    }
    getMonthlyAssessmentV101() {
        return this.axios.get(`${this.apiRoot}/checkin/monthly/V101`, this.getHttpConfig())
            .then(response => response.data);
    }
    saveMonthlyAssessmentV101(data) {
        return this.axios.post(`${this.apiRoot}/checkin/monthly/V101`, data, this.getHttpConfig())
            .then(response => response.data);
    }
    saveUserCareer(career) {
        return this.axios.put(`${this.apiRoot}/users/me/career`, { career }, this.getHttpConfig())
            .then(response => response.data);
    }
    saveUserInterests(interests) {
        return this.axios.put(`${this.apiRoot}/users/me/interests`, { interests }, this.getHttpConfig())
            .then(response => response.data);
    }
    getCurrentUser() {
        return this.axios.get(`${this.apiRoot}/users/me`, this.getHttpConfig())
            .then(response => response.data);
    }
    getConfig() {
        return this.axios.get(`${this.apiRoot}/users/config`, this.getHttpConfig())
            .then(response => response.data);
    }
    logout() {
        return localStorage.removeItem(AUTH_TOKEN);
    }
    ;
    setAuthCredentials(token) {
        return localStorage.setItem(AUTH_TOKEN, token);
    }
    ;
    getAuthCredentials() {
        return localStorage.getItem(AUTH_TOKEN);
    }
    ;
    setRedirectUrl(url) {
        return localStorage.setItem(REDIRECT_URL, url);
    }
    ;
    getRedirectUrl() {
        return localStorage.getItem(REDIRECT_URL);
    }
    ;
    clearRedirectUrl() {
        return localStorage.removeItem(REDIRECT_URL);
    }
    ;
    sendLoginEmail(email) {
        return this.axios.post(`${this.apiRoot}/login`, { email })
            .then(response => response.data);
    }
    ;
    sendCodeLoginEmail(email) {
        return this.axios.post(`${this.apiRoot}/code-login`, { email })
            .then(response => response.data);
    }
    ;
    verifyCodeLogin(email, code) {
        return this.axios.post(`${this.apiRoot}/code-login/verify`, { email, code })
            .then(response => response.data);
    }
    ;
    deleteJourneyUserCheckinAnswers() {
        return this.axios.delete(`${this.apiRoot}/checkin`, this.getHttpConfig())
            .then(response => response.data);
    }
    ;
    submitResourcesAskQuestionForm(data) {
        return this.axios.post(`${this.apiRoot}/eap/askquestion`, data, this.getHttpConfig())
            .then(response => response.data);
    }
    ;
    getCompanyBenefitsInfo() {
        return this.axios.get(`${this.apiRoot}/users/me/benefits`, this.getHttpConfig())
            .then(response => response.data);
    }
    getDailyJourneyInfo() {
        return this.axios.get(`${this.apiRoot}/users/me/daily-journey`, this.getHttpConfig())
            .then(response => response.data);
    }
    getOlderDailyJourneyInfo(count, startingDate) {
        return this.axios.get(`${this.apiRoot}/users/me/daily-journey/older/${count}/${startingDate}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getNewerDailyJourneyInfo(count, startingDate) {
        return this.axios.get(`${this.apiRoot}/users/me/daily-journey/newer/${count}/${startingDate}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getDailyJourneyById(id) {
        return this.axios.get(`${this.apiRoot}/daily-journey/${id}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getRecommendations() {
        return this.axios.get(`${this.apiRoot}/users/me/recommendations`, this.getHttpConfig())
            .then(response => response.data);
    }
    getIonicRecommendations() {
        return this.axios.get(`${this.apiRoot}/users/me/ionic-recommendations`, this.getHttpConfig())
            .then(response => response.data);
    }
    userMarketingOptIn() {
        return this.axios.post(`${this.apiRoot}/marketing-opt-in`, null, this.getHttpConfig())
            .then(response => response.data);
    }
    getCategory(id) {
        return this.axios.get(`${this.apiRoot}/vimeo/category/${id}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getPlaylist(id) {
        return this.axios.get(`${this.apiRoot}/vimeo/playlist/${id}`, this.getHttpConfig())
            .then(response => response.data);
    }
    /**
     * @param options.excludeLiveCategory if true, the response will not include the category corresponding to live streams
     */
    getHomeContent(options = {}) {
        var requestUrl = `${this.apiRoot}/video/home`;
        if (options.excludeLiveCategory === true) {
            requestUrl = requestUrl + "?excludeLiveCategory=1";
        }
        return this.axios.get(requestUrl, this.getHttpConfig())
            .then(response => response.data);
    }
    getFeaturedContent() {
        return this.axios.get(`${this.apiRoot}/content/home/featured`, this.getHttpConfig())
            .then(response => response.data);
    }
    getContinueWatching() {
        return this.axios.get(`${this.apiRoot}/videoactivity/continuewatching`, this.getHttpConfig())
            .then(response => response.data);
    }
    getSavedVideos() {
        return this.axios.get(`${this.apiRoot}/savedcontent`, this.getHttpConfig())
            .then(response => response.data);
    }
    getNextVideoInPlaylist(videoId, playlistId) {
        return this.axios.get(`${this.apiRoot}/video/next/${playlistId}/${videoId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getNextVideoInAnyPlaylist(videoId) {
        return this.axios.get(`${this.apiRoot}/video/next/${videoId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getLiveStreamContent() {
        return this.axios.get(`${this.apiRoot}/content/home/live-streams`, this.getHttpConfig())
            .then(response => response.data);
    }
    getLiveStreamComments(liveStreamId) {
        return this.axios.get(`${this.apiRoot}/live-stream/comments/${liveStreamId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    createLiveStreamComment(comment, liveStreamId) {
        return this.axios.post(`${this.apiRoot}/live-stream/comment`, { comment, liveStreamId }, this.getHttpConfig())
            .then(response => response.data);
    }
    getVideoComments(videoId) {
        return this.axios.get(`${this.apiRoot}/vimeo/comments/${videoId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    createVideoComment(comment, videoId) {
        return this.axios.post(`${this.apiRoot}/comment`, { comment, videoId }, this.getHttpConfig())
            .then(response => response.data);
    }
    reportComment(commentId) {
        return this.axios.put(`${this.apiRoot}/comment/report`, { commentId }, this.getHttpConfig())
            .then(response => response.data);
    }
    getDailyVideoInfo() {
        return this.axios.get(`${this.apiRoot}/users/me/daily-video`, this.getHttpConfig())
            .then(response => response.data);
    }
    getLiveStreamInfo(id) {
        return this.axios.get(`${this.apiRoot}/live-stream/${id}`, this.getHttpConfig())
            .then(response => response.data);
    }
    async getDailyPractice() {
        const response = await this.axios.get(`${this.apiRoot}/video/daily-practice`, this.getHttpConfig());
        return response.data;
    }
    async getTodaysActivity() {
        const response = await this.axios.get(`${this.apiRoot}/monthlyactivity/today`, this.getHttpConfig());
        return response.data;
    }
    async getMonthlyActivity() {
        const response = await this.axios.get(`${this.apiRoot}/monthlyactivity/month`, this.getHttpConfig());
        return response.data;
    }
    async recordActivity(type) {
        await this.axios.post(`${this.apiRoot}/monthlyactivity`, { type }, this.getHttpConfig());
    }
    async getLastThirtyDailyCheckins() {
        const response = await this.axios.get(`${this.apiRoot}/checkin/last-thirty`, this.getHttpConfig());
        return response.data;
    }
    getHttpConfig() {
        const token = localStorage.getItem(AUTH_TOKEN);
        const axiosConfig = {};
        if (token) {
            axiosConfig.headers = {
                "Authorization": `Bearer ${token}`
            };
        }
        return axiosConfig;
    }
    ;
    searchByTitle(title) {
        return this.axios.get(`${this.apiRoot}/content?search=${title}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getRealmDiscovery(email) {
        return this.axios.get(`${this.apiRoot}/users/realm-discovery/${email}`)
            .then(response => response.data);
    }
    deleteUser() {
        return this.axios.delete(`${this.apiRoot}/users/me`, this.getHttpConfig())
            .then(response => response.data);
    }
    getVideoById(id) {
        return this.axios.get(`${this.apiRoot}/watch/video/${id}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getPublicVideoById(id) {
        return this.axios.get(`${this.apiRoot}/video/public/${id}`, this.getHttpConfig())
            .then(response => response.data);
    }
    loginWithPassword(email, password) {
        return this.axios.post(`${this.apiRoot}/passwordlogin`, { email, password }, this.getHttpConfig())
            .then(response => response.data);
    }
    saveVideo(videoId) {
        return this.axios.put(`${this.apiRoot}/savedcontent`, {
            videoId
        }, this.getHttpConfig())
            .then(response => response.data);
    }
    saveVideoPlaylist(playlistId) {
        return this.axios.put(`${this.apiRoot}/savedcontent`, {
            playlistId
        }, this.getHttpConfig())
            .then(response => response.data);
    }
    removeSavedVideo(videoId) {
        return this.axios.delete(`${this.apiRoot}/savedcontent/video/${videoId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    removeSavedVideoPlaylist(playlistId) {
        return this.axios.delete(`${this.apiRoot}/savedcontent/playlist/${playlistId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    logVideoWatch(videoId, position, duration) {
        return this.axios.put(`${this.apiRoot}/videoactivity/watch`, {
            videoId,
            position,
            duration
        }, this.getHttpConfig())
            .then(response => response.data);
    }
    getZoomAppHomeContent() {
        return this.axios.get(`${this.apiRoot}/zoomapp/home/content`, this.getHttpConfig())
            .then(response => response.data);
    }
    setUserHasMobileApp() {
        return this.axios.post(`${this.apiRoot}/users/me/installed-app`, null, this.getHttpConfig())
            .then(response => response.data);
    }
    setUserAddedMindfulBreak() {
        return this.axios.post(`${this.apiRoot}/users/me/added-mindful-break`, null, this.getHttpConfig())
            .then(response => response.data);
    }
    setUserHasZoomApp() {
        return this.axios.post(`${this.apiRoot}/users/me/installed-zoom-app`, null, this.getHttpConfig());
    }
    setUserAsMhamChampion() {
        return this.axios.post(`${this.apiRoot}/users/me/become-mham-champion`, null, this.getHttpConfig());
    }
    setUserAsMhamParticipant(champion) {
        return this.axios.post(`${this.apiRoot}/users/me/become-mham-participant`, { champion }, this.getHttpConfig());
    }
    //----------------------------------- Resources --------------------------------------------------
    getResourcesLanguages() {
        return this.axios.get(`${this.apiRoot}/resources/languages`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesDefaultLanguage() {
        return this.axios.get(`${this.apiRoot}/resources/languages/default`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesLanguage(languageId) {
        return this.axios.get(`${this.apiRoot}/resources/languages/${languageId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentDivisions() {
        return this.axios.get(`${this.apiRoot}/resources/divisions`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentModuleByDivisionId(divisionId) {
        return this.axios.get(`${this.apiRoot}/resources/modules?divisionId=${divisionId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentByDivisionId(divisionId) {
        return this.axios.get(`${this.apiRoot}/resources/divisions/${divisionId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentCategoriesByModuleId(moduleId) {
        return this.axios.get(`${this.apiRoot}/resources/categories?moduleId=${moduleId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentArticleByCategoryId(categoriesIdStringedArray) {
        return this.axios.get(`${this.apiRoot}/resources/articles?categoryId=${categoriesIdStringedArray}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentModule(moduleId) {
        return this.axios.get(`${this.apiRoot}/resources/modules/${moduleId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentArticle(articleId) {
        return this.axios.get(`${this.apiRoot}/resources/articles/${articleId}`, this.getHttpConfig())
            .then(response => response.data);
    }
    getResourcesContentFeaturedArticle() {
        return this.axios.get(`${this.apiRoot}/resources/articles/featured`, this.getHttpConfig())
            .then(response => response.data);
    }
    getTeacher(id) {
        return this.axios.get(`${this.apiRoot}/teacher/${id}`, this.getHttpConfig())
            .then(response => response.data);
    }
    signupToEvent(email, eventName, companyCode) {
        return this.axios.post(`${this.apiRoot}/code-login/eventsignup`, { eventName, email, companyCode })
            .then(response => response.data);
    }
}
exports.JourneyApiClient = new ApiServiceImpl();
